<template>
  <div>
    <!--    使用者註冊-->
    <div v-if="auth>=2">
      <el-button style="float: left;margin:10px;" type="primary" @click="dialogFormVisible=true">新增職員</el-button>
    </div>
    <el-dialog :visible.sync="dialogFormVisible" title="註冊資料">
      <el-form ref="registerForm" :model="form" :rules="rules">
        <el-form-item :label-width="formLabelWidth" label="Name" prop="name">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="Email" prop="email">
          <el-input v-model="form.email" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="Password" prop="pwd1">
          <el-input v-model="form.pwd1" type="password"></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="再次輸入" prop="pwd2">
          <el-input v-model="form.pwd2" type="password"></el-input>
        </el-form-item>
        <span>{{ this.checkMsg }}</span>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button :disabled="!canAddUser" type="primary" @click="addUser">确 定</el-button>
      </div>
    </el-dialog>
    使用者列表
    <el-table
        :data="data"
        height="80vh"
    >
      <el-table-column prop="EID" label="編號" min-width="8%"></el-table-column>
      <el-table-column prop="NAME" label="姓名" min-width="25%">
        <template scope="{row}">
          <div v-if="row.edit.includes('NAME')">
            <el-input v-model.trim="row.NAME"></el-input>
            <el-button @click="updateAccountName(row)" type="mini">完成</el-button>
          </div>
          <span v-else>
          {{ row.NAME }}
            <el-button
                v-if="auth>=1"
                @click="toggleEditState('NAME',row)"
                type="mini">編輯
          </el-button>
          </span>

        </template>
      </el-table-column>
      <el-table-column prop="MAIL" label="MAIL" min-width="30%"></el-table-column>
      <el-table-column prop="AUTH" label="權限等級" min-width="20%">
        <template slot-scope="{row}">

          <div v-if="row.edit.includes('AUTH')">
            <el-select v-model="row.AUTH" placeholder="请选择">
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
            <el-button @click="saveAuth('AUTH',row)">完成</el-button>
          </div>
          <div v-else>
            {{ options.filter(el => el.value === row.AUTH)[0].label }}
            <el-button
                v-if="auth>1"
                @click="toggleEditState('AUTH',row)"
                type="mini">編輯
            </el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column
          v-if="auth>1"
          label="功能">
        <template slot-scope="{row}">
          <span style="display: inline-block">
            <el-button @click="deleteAccount(row)" type="primary">刪除</el-button>
          </span>
          <span style="display: inline-block;margin-left: 10px;">
            <ResetPw :eid="row.EID" type="primary"/>
          </span>
        </template>
      </el-table-column>

    </el-table>
  </div>
</template>

<script>
import {
  accountAuthEdit,
  accountDel,
  accountEditName,
  accountList,
  accountPasswordEdit,
  accountRegister,
  getAuth
} from "@/api";
import EditableTable from "@/components/EditableTable";
import ResetPw from "@/components/ResetPw";

const triggerConfig = ['change', 'blur']
export default {
  name: "Account",
  components: {EditableTable, ResetPw},
  computed: {
    auth() {
      return getAuth()
    },
    canAddUser() {
      return this.checkMsg === ''
    }
  },
  data() {
    return {
      dialogFormVisible: false,
      formLabelWidth: '120px',
      form: {
        name: '',
        email: '',
        pwd1: '',
        pwd2: ''
      },
      data: [],
      options: [
        {value: 0, label: '未開通'},
        {value: 1, label: '使用者'},
        {value: 2, label: '管理者'},
      ],
      checkMsg: '',
      rules: {
        name: [
          {required: true, message: '请输入名字', trigger: 'change'},
          {min: 2, message: '請輸入至少 2 個字母', trigger: 'change'}
        ],
        email: [
          {required: true, message: '请输入 Email', trigger: 'change'},
          {type: 'email', message: '請輸入正確的 Email', trigger: triggerConfig}
        ],
        pwd1: [
          {required: true, message: '请输入密碼', trigger: 'blur'},
          {min: 3, max: 10, message: '長度在 3 到 10 個字母', trigger: triggerConfig}
        ],
        pwd2: [
          {required: true, message: '再次輸入密碼', trigger: 'blur'},
          {min: 3, max: 10, message: '長度在 3 到 10 個字母', trigger: triggerConfig}
        ],
      }
    }
  },
  watch: {
    form: {
      handler(newVal, oldVal) {
        console.log(`${newVal.pwd1} ${newVal.pwd2}`);
        let result
        if (newVal.pwd1 && newVal.pwd2 && newVal.pwd1 === newVal.pwd2) {
          result = ''
        } else {
          result = '密碼不同'
        }
        this.checkMsg = result
      },
      deep: true
    },
  },
  methods: {
    // new
    toggleEditState(column, row) {
      if (row.edit === undefined) row.edit = []

      if (row.edit.includes(column)) {
        const i = row.edit.findIndex(el => el === column)
        row.edit.splice(i, 1)
      } else {
        row.edit.push(column)
      }
      console.log(row);
    },
    saveAuth(column, row) {
      const {EID, AUTH} = row
      accountAuthEdit({EID, AUTH})
          .then(res => {
            this.$message.success("權限變更成功")
          })
          .catch(e => {
            this.$message.error("權限變更失敗")
          })
      this.toggleEditState(column, row)
    },
    deleteAccount(row) {
      const {EID, PWD, AUTH} = row
      this.$confirm('此操作将永久删除该帳號, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        accountDel({AID: EID})
            .then(res => {
              const i = this.data.findIndex(el => el.EID === EID)
              this.data.splice(i, 1)
              this.$message.success('删除成功!')
            })
            .catch(e => {
              this.$message.error('刪除失敗')
            })
      }).catch(() => {
        this.$message.info('已取消删除')
      });
    },
    //
    onSave({columnName, data}) {
      const {EID, PWD, AUTH} = data
      switch (columnName) {
        case 'PWD':
          accountPasswordEdit({EID, PWD})
              .then(res => {
                this.$message.success("密碼變更成功")
              })
              .catch(e => {
                this.$message.error("密碼變更失敗")
              })
          break
        case 'AUTH':
          this.toggleEditState(columnName, data)
          accountAuthEdit({EID, AUTH})
              .then(res => {
                this.$message.success("權限變更成功")
              })
              .catch(e => {
                this.$message.error("權限變更失敗")
              })
      }
    },
    resetFormData() {
      this.form = {
        name: '',
        email: '',
        pwd1: '',
        pwd2: ''
      }
    },
    addUser() {
      if (this.canAddUser) {
        this.dialogFormVisible = false
        accountRegister({ID: this.form.email, NAME: this.form.name, PWD: this.form.pwd1})
            .then(res => {
              this.fetchAccountList()
            })
        this.resetFormData()
      }
    },
    fetchAccountList() {
      accountList()
          .then(data => {
            data.LIST.forEach(item => {
              item.edit = []
            })
            this.data = data.LIST
          })
    },
    updateAccountName(row) {
      const {EID, NAME} = row
      accountEditName({EID, NAME})
          .then(res => {
            this.toggleEditState('NAME', row)
            this.$message.success('姓名更新成功')
          })
          .catch(e => {
            this.$message.error('姓名更新失敗')
          })
    }
  },
  created() {
    this.fetchAccountList()
  }
}
</script>

<style scoped>

</style>
